import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-scn-range',
  templateUrl: './scn-range.component.html',
  styleUrls: [],
  standalone: false
})
export class SCNRangeComponent {
  @Input() from: any = null;
  @Input() to: any = null;

  @Output() readonly fromChange = new EventEmitter();
  @Output() readonly toChange = new EventEmitter();

  constructor() {}
}
